//
//  useCsvSummarySelector.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useState, useEffect } from "react";
import { csvSummaryItems } from "../constants/csv";
import { localStorageManager } from "../utils/localStorage";

const LOCAL_STORAGE_KEY = localStorageManager.SELECTED_CSV_SUMMARY_ITEMS;

const useCsvSummarySelector = () => {
  const [selectedCsvSummaryItems, setSelectedCsvSummaryItems] = useState<string[]>([]);
  const allItems = csvSummaryItems.map((item) => item.type);

  const loadSelectedItems = () => {
    const stored = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "[]");
    if (stored.length) {
      setSelectedCsvSummaryItems(stored);
    } else {
      setSelectedCsvSummaryItems(allItems);
    }
  };

  // 初期化処理
  useEffect(() => {
    loadSelectedItems();
  }, []);

  // 状態変更時の保存処理
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(selectedCsvSummaryItems));
  }, [selectedCsvSummaryItems]);

  const errorMsg =
    selectedCsvSummaryItems.length === 0
      ? "1つ以上のサマリー項目を選択してください。"
      : "";

  return {
    selectedCsvSummaryItems,
    setSelectedCsvSummaryItems,
    errorMsg,
  };
};

export default useCsvSummarySelector;
